import { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import Form from 'react-bootstrap/Form'

export const parseList = (text) =>
  text
    .split(/[\n,]/)
    .map((entry) => entry.trim())
    .filter(Boolean)

const asText = (list) => list.join('\n')

// A list-valued config setting edited as text, one entry per line or
// comma-separated. The textarea keeps what was typed: rebuilding it from the
// parsed list would eat a trailing comma or newline the moment it was typed.
// Entries that wrap or contain commas use ListRowsConfigInput instead.
const ListConfigInput = ({ value, onChange, disabled = false }) => {
  const list = Array.isArray(value) ? value : []
  const [draft, setDraft] = useState(asText(list))
  const lastEmitted = useRef(asText(list))

  // Follow changes made outside this input, e.g. a reset to saved values.
  useEffect(() => {
    if (asText(list) !== lastEmitted.current) {
      lastEmitted.current = asText(list)
      setDraft(asText(list))
    }
  }, [list])

  const handleChange = (e) => {
    const parsed = parseList(e.target.value)
    setDraft(e.target.value)
    lastEmitted.current = asText(parsed)
    onChange(parsed)
  }

  return (
    <>
      <Form.Control
        as="textarea"
        rows={3}
        value={draft}
        onChange={handleChange}
        placeholder="One per line, or comma-separated"
        disabled={disabled}
      />
      <Form.Text className="text-muted d-block" data-testid="list-config-hint">
        Enter one per line, or separate entries with commas.
      </Form.Text>
    </>
  )
}

ListConfigInput.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
}

export default ListConfigInput
